"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT = exports.TEXT_EDITOR_CONFIG = exports.TEXT_FORMATTER_CONFIG = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const types_1 = require("./types");
const cell_formatter_1 = require("./cell-formatter");
const cell_editor_1 = require("./cell-editor");
const lodash_1 = require("lodash");
exports.TEXT_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({
    path: z.string().optional(),
    valueMap: z.record(z.any()).optional()
});
exports.TEXT_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({
    autocomplete: z
        .string()
        .optional()
        .default('off'),
    placeholder: z.string().optional()
});
exports.TEXT = {
    name: 'text',
    formatter: {
        schema: exports.TEXT_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                component: {
                    name: 'TextFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile(`<span class="text-wrap">{{ valueMap ? valueMap[value] : (path ? getvalue(value) : value) }}</span>`),
                    data() {
                        return {
                            path: config.path,
                            valueMap: config.valueMap
                        };
                    },
                    methods: {
                        getvalue(value) {
                            if ((0, lodash_1.isObject)(value) && config.path) {
                                return (0, lodash_1.get)(value, config.path);
                            }
                        }
                    }
                }
            };
        }
    },
    editor: {
        schema: exports.TEXT_EDITOR_CONFIG,
        createComponent(config) {
            return {
                textAlign: 'left',
                component: {
                    name: 'TextEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<b-form-input
              type=text
              v-model=currentValue
              :autocomplete=autocomplete
              :id=col.field
              :name=col.name
              :form="formId"
              :tabindex="col.effectiveTabindex"
              :placeholder="placeholder"
              :size=col.size
              :state=validationState
              :disabled="isDisabled"
              @change="onChange($event)"
            ></b-form-input>`),
                    data() {
                        return {
                            autocomplete: config.autocomplete,
                            placeholder: config.placeholder
                        };
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=text.js.map